import xhr from '~/frontend/src/utilities/xhr';
import {
    METAMODEL_LOAD,
    METAMODEL_RELOAD,
    METAMODEL_RECEIVE
} from '~/frontend/src/constants';
import {
    AppDispatch,
    Thunk
} from '~/frontend/src/store';
import metaModel from '~/shared/src/utilities/metaModel';
import startRequest from '~/frontend/src/actions/ajax/startRequest';
import endRequest from '~/frontend/src/actions/ajax/endRequest';


export type LoadAction = {
    type : typeof METAMODEL_LOAD;
}

/**
 * @memberOf! Actions
 *
 * @return {function}
 */
export const load = () : Thunk<Promise<void>> => async ( dispatch : AppDispatch ) : Promise<void> => {
    dispatch( {
        type: METAMODEL_LOAD
    } );

    dispatch( startRequest(
        () => {
        },
        'global_non_masking',
        'loadProcessingMetaModel'
    ) );

    let result : Awaited<ReturnType<typeof xhr.post>> | undefined;

    try {
        result = await xhr.post(
            `${BASE_URL}/api/metamodel/load`,
            undefined,
            undefined,
            'global_non_masking',
            'loadMetaModel',
            dispatch
        );

        if ( result?.data.data ) {
            const data = result.data.data;

            for ( const schema of Object.keys( metaModel ) ) {
                metaModel[ schema ].fromJsonString(
                    data[ schema ].metaData, data[ schema ].metaDataTimestamp
                );
            }
        }
    }
    finally {
        // always end the masking request, even if loading/parsing threw
        dispatch( endRequest(
            () => {
            },
            'global_non_masking',
            'loadProcessingMetaModel'
        ) );
    }

    dispatch( receive( result?.data.data ) );
}


export type ReloadAction = {
    type : typeof METAMODEL_RELOAD;
};

/**
 * @memberOf! Actions
 *
 * @return {function}
 */
export const reload = () : Thunk<Promise<void>> => async ( dispatch : AppDispatch ) : Promise<void> => {
    dispatch( {
        type: METAMODEL_RELOAD
    } );

    dispatch( startRequest(
        () => {
        },
        'global_non_masking',
        'reloadProcessingMetaModel'
    ) );

    let result : Awaited<ReturnType<typeof xhr.post>> | undefined;

    try {
        result = await xhr.post(
            `${BASE_URL}/api/metamodel/reload`,
            undefined,
            undefined,
            'global_non_masking',
            'reloadMetaModel',
            dispatch
        );

        if ( result?.data.data ) {
            const data = result.data.data;

            for ( const schema of Object.keys( metaModel ) ) {
                metaModel[ schema ].fromJsonString(
                    data[ schema ].metaData, data[ schema ].metaDataTimestamp
                );
            }
        }
    }
    finally {
        // always end the masking request, even if loading/parsing threw
        dispatch( endRequest(
            () => {
            },
            'global_non_masking',
            'reloadProcessingMetaModel'
        ) );
    }

    dispatch( receive( result?.data.data ) );
}


export type ReceiveAction = {
    type : typeof METAMODEL_RECEIVE;
    data : any;
};

/**
 * @memberOf! Actions
 *
 * @param {any} data
 *
 * @return {ReceiveAction}
 */
const receive = ( data : any ) : ReceiveAction => {
    return {
        type: METAMODEL_RECEIVE,
        data
    };
}
